import { apiClient } from "@apis/apiClient";
import apiUtils from "@apis/apiUtils";

/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
  search(params: any) {
    return apiClient.post(`/rest/search`, params, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  searchWithCancelToken(params: any, cancelToken: any) {
    return apiClient.post(`/rest/search`, params, {
      cancelToken: cancelToken,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },

  getDescriptors(queryObjectType: any, params: any, orgParam: any, channelId: any) {
    const paramsWithChannel = channelId ? { ...params, channelId } : params;
    return apiClient.get(
      apiUtils.buildParamsListURI(
        `/rest/search/gui/basic/filter/descriptors/${queryObjectType}` +
          (orgParam || ""),
        paramsWithChannel
      )
    );
  },

  getFilterColumns(queryObjectType: any, params: any, orgParam: any, channelId: any) {
    const paramsWithChannel = channelId ? { ...params, channelId } : params;
    return apiClient.get(
      apiUtils.buildParamsListURI(
        `/rest/search/gui/table/descriptors/${queryObjectType}` +
          (orgParam || ""),
        paramsWithChannel
      )
    );
  },

  getSuggestion(params: any) {
    return apiClient.get(`/rest${params.url}`);
  },

  getSuggestionActivityState() {
    return apiClient.get(
      `/rest/search/gui/filter/suggestion/lastActivityState`,
      {}
    );
  },

  getSuggestionThirdPartyEnum(filterKey: any, params: any) {
    return apiClient.post(
      `/rest/search/gui/filter/suggestion/enum/${filterKey}`,
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  getSuggestionGeozoneByLastGeozoneTags(params: any) {
    return apiClient.post(
      `/rest/search/gui/filter/suggestion/geozoneFiltered/lastGeozoneTags`,
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  getSuggestionDeviceByLastGeozoneTags(params: any) {
    return apiClient.post(
      `/rest/search/gui/filter/suggestion/deviceFiltered/lastGeozoneTags`,
      JSON.stringify(params),
      {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      }
    );
  },

  getSystemTags(params: any) {
    return apiClient.get(
      `/rest/search/gui/filter/suggestion/device/systemTags`,
      { params: params }
    );
  },

  getPartnerTags(params: any) {
    return apiClient.get(
      `/rest/search/gui/filter/suggestion/device/partnerTags`,
      { params: params }
    );
  },

  searchCount(params: any) {
    return apiClient.post("/rest/search/count", params, {
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });
  },
};
